<template>
	<div>
		<div class="container" v-if="!user">
			<div class="row mt-5 position-relative">
				<div class="col-12 offset-md-4 col-md-4 position-absolute" style="bottom: -312px;">
	              	<div class="form-group">
				    	<input type="text" class="form-control" id="email" placeholder="Email">
				  	</div>
				  	<div class="form-group">
				   		<input type="password" class="form-control" id="password" placeholder="Password">
				  	</div>
	              <button @click="isUserValid" class="text-white login-btn bg-dark">Sign in</button>
	          	</div>
			</div>
		</div>
		<div v-if="user">
			<navbar></navbar>
		    <router-view></router-view>
	  </div>
	</div>
</template>

<script>
	import Navbar from './components/Navbar.vue';
	import firebase from 'firebase';

	export default {
	  	data: function () {
      		return {
	      		user: false
	    	}
	  	},
	  	components: {
	  		'navbar' : Navbar
	  	},
	  	methods: {
	    	isUserValid: function(){
	    		let email = document.getElementById("email").value;
	    		let password = document.getElementById("password").value;

	    		firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
			  		let errorCode = error.code;
			  		let errorMessage = error.message;
				});
	    	}
	  	},
	  	created: function(){
	  		let self = this;
		    firebase.auth().onAuthStateChanged(function(user) {
			  	if (user) {
			    	self.user = true;
	      			//self.$router.push({path: '/admin'});
			  	} else {
			  		self.user = false;
			   		//self.$router.push({path: ''});
			  	}
			});
		}
	}
</script>
<style src="./assets/css/bootstrap.min.css"></style>
<style src="./assets/css/style.css"></style>


// WEBPACK FOOTER //
// src/App.vue